import React, { useMemo } from 'react';
import {
  FaBell,
  FaChevronRight,
  FaGlobe,
  FaLayerGroup,
  FaMoon,
  FaRedoAlt,
  FaSun,
  FaVolumeMute,
  FaVolumeUp,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useTheme } from '../../context/ThemeContext';
import { useCheckinNotifications } from './useCheckinNotifications';

function AdminPageHeader({
  icon: Icon,
  eyebrow,
  title,
  description,
  actions,
  breadcrumbs = [],
  meta,
}) {
  const { isDark, toggleTheme } = useTheme();
  const { soundEnabled, toggleSound } = useCheckinNotifications({
    poll: false,
    listenDirect: false,
  });
  const currentUser = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('userData') || '{}');
    } catch (error) {
      return {};
    }
  }, []);

  const displayName =
    currentUser.full_name ||
    currentUser.name ||
    currentUser.username ||
    currentUser.AdminName ||
    'Admin';
  const displayRole = currentUser.role || currentUser.level || 'Administrator';
  const breadcrumbTrail =
    breadcrumbs.length > 0 ? breadcrumbs.map(item => item.label) : [title];

  const showNotificationInfo = () => {
    toast.info('Notifikasi check-in aktif dan akan tampil otomatis di panel admin.');
  };

  return (
    <>
      <div className="page-topbar-shell">
        <div className="page-topbar">
          <div className="page-topbar__crumbs">
            <FaLayerGroup />
            <FaGlobe />
            <span className="page-topbar__trail">
              <span>Administrasi</span>
              {breadcrumbTrail.map(label => (
                <React.Fragment key={label}>
                  <FaChevronRight />
                  <span>{label}</span>
                </React.Fragment>
              ))}
            </span>
          </div>

          <div className="page-topbar__actions">
            <div className="page-topbar__profile">
              <strong>{displayName}</strong>
              <small>{displayRole}</small>
            </div>

            <button
              type="button"
              className="page-topbar__button"
              onClick={toggleTheme}
              aria-label={isDark ? 'Aktifkan mode terang' : 'Aktifkan mode gelap'}
              title={isDark ? 'Mode terang' : 'Mode gelap'}
            >
              {isDark ? <FaSun /> : <FaMoon />}
            </button>

            <button
              type="button"
              className="page-topbar__button"
              onClick={() => window.location.reload()}
              aria-label="Muat ulang halaman"
              title="Muat ulang halaman"
            >
              <FaRedoAlt />
            </button>

            <button
              type="button"
              className="page-topbar__button"
              onClick={showNotificationInfo}
              aria-label="Informasi notifikasi"
              title="Informasi notifikasi"
            >
              <FaBell />
            </button>

            <button
              type="button"
              className={`page-topbar__button ${soundEnabled ? 'is-active' : ''}`}
              onClick={toggleSound}
              aria-label={soundEnabled ? 'Matikan suara notifikasi' : 'Aktifkan suara notifikasi'}
              title={soundEnabled ? 'Suara aktif' : 'Suara nonaktif'}
            >
              {soundEnabled ? <FaVolumeUp /> : <FaVolumeMute />}
            </button>
          </div>
        </div>
      </div>

      <div className="page-header-card">
        <div className="page-header-content">
          <div className="page-header-main">
            <div className="page-header-intro">
              {Icon ? (
                <span className="page-icon-orb">
                  <Icon />
                </span>
              ) : null}

              <div className="page-header-copy">
                {eyebrow ? <span className="page-eyebrow">{eyebrow}</span> : null}
                <h1 className="page-title">{title}</h1>
                {description ? <p className="page-description">{description}</p> : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      {meta || actions ? (
        <div className="page-commandbar-card">
          {meta ? <div className="page-meta">{meta}</div> : <div />}
          {actions ? <div className="page-actions">{actions}</div> : null}
        </div>
      ) : null}
    </>
  );
}

export default AdminPageHeader;
